module.exports = __webpack_public_path__ + "img/e082de7.png";